<template>
  <div v-if="purpose" class="mt-3">
    <h6>เอกสารที่ใช้ประกอบการยื่นนัดหมาย</h6>
    <ul v-if="purpose.documents && purpose.documents.length">
      <li v-for="document in purpose.documents" :key="document">{{ document }}</li>
    </ul>
    <p v-else class="text-muted font-weight-light font-italic">{{ purpose.requires_detail ? 'ไม่ได้กำหนดรายการเอกสาร สามารถแนบข้อมูลประกอบเพิ่มเติมได้' : 'ไม่จำเป็นต้องแนบเอกสาร (ไม่บังคับ)' }}</p>
  </div>
</template>
<script>
export default { props: { purpose: { type: Object, default: null } } };
</script>
